import {useContext} from 'react';

import {MenuItem, Stack, TextField, useTheme} from '@mui/material';

import {LanguageContext} from '../../../../contexts/LanguageContext/LanguageContext';
import {getFieldStyle} from '../../../../layouts/theme/FieldStyles';
import {DateOptions} from '../../../../lib/constants';

interface Duration {
  amount: string;
  unit: 'years' | 'months';
}
interface Props {
  onChange: (duration: Duration) => void;
  value: Duration;
}
export const DurationSelect = ({onChange, value}: Props) => {
  const theme = useTheme();
  const currentLanguage = useContext(LanguageContext);

  return (
    <Stack direction='row' spacing={1} sx={{marginTop: 1}}>
      <TextField
        size='small'
        value={value.amount}
        type='number'
        onChange={(e) => onChange({...value, amount: e.target.value})}
        fullWidth
        variant='outlined'
        sx={getFieldStyle(theme)}
        inputProps={{
          'data-testid': 'duration-input',
        }}
      />
      <TextField
        select
        sx={getFieldStyle(theme)}
        fullWidth
        size='small'
        value={value.unit}
        onChange={(e) => onChange({...value, unit: e.target.value as 'years' | 'months'})}
        variant='outlined'
        data-testid='duration-unit-input'
      >
        {DateOptions.map((option) => (
          <MenuItem key={option.id} value={option.id} data-testid={`duration-unit-${option.id}`}>
            {option.label[currentLanguage]}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
};
